var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{staticClass:"text-center",attrs:{"centered":"","size":"xl","id":"map-modal","title":'Room: ' + _vm.room,"hide-footer":""}},[_c('img',{staticClass:"map",staticStyle:{"width":"100%"},attrs:{"src":'/static/map/' + _vm.room + '.jpg',"alt":"","aria-hidden":"true"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95d8e5da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/MapModal.vue
// module id = QEo0
// module chunks = 1